import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesHighlight from './components/ServicesHighlight';
import AboutPreview from './components/AboutPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import { useTitle } from '@/hooks/useTitle';

export default function Home() {
  useTitle({
    title: '保險建築師｜讓安心成為您的人生主結構',
    description: '保險建築師專注醫療保險、家庭保障、長期照護、退休規劃與保單健檢，透過傾聽、診斷、設計與追蹤，協助您建立更穩定的人生保障結構。',
  });
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ServicesHighlight />
      <AboutPreview />
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </main>
  );
}
